import { useEffect, useState } from "react";
import { Col, Input, Label, Row, Card, CardBody } from "reactstrap";
import { FiTruck, FiSettings } from "react-icons/fi";
import FormInput from "../../formInput/FormInput";
import { Tooltip } from "antd";
import { FaQuestionCircle } from "react-icons/fa";

const Step4LogisticsMedia = ({ newItem, setNewItem, newItemSettings }) => {
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        if (newItem?.tempImageFile) {
            const objectUrl = URL.createObjectURL(newItem.tempImageFile);
            setPreviewUrl(objectUrl);
            return () => URL.revokeObjectURL(objectUrl);
        } else if (newItem?.imageUrl) {
            setPreviewUrl(newItem.imageUrl);
        } else {
            setPreviewUrl(null);
        }
    }, [newItem?.tempImageFile, newItem?.imageUrl]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setNewItem({
            ...newItem,
            tempImageFile: file,
        });
    };

    return (
        <>
            <Card className="border-0 shadow-sm mb-4 bg-light">
                <CardBody className="p-4">
                    <div className="d-flex align-items-center gap-2 mb-4 pb-2 border-bottom">
                        <div className="bg-primary-soft p-2 rounded-3 text-primary">
                            <FiTruck size={16} />
                        </div>
                        <h6 className="fw-bold text-dark mb-0 text-uppercase tracking-wider" style={{ fontSize: '13px' }}>Logistics & Media</h6>
                    </div>
                    <Row className="g-2">
                <Col md={12} className="mb-3">
                    <Row className="align-items-end">
                        <Col md={8}>
                            <FormInput
                                type={"url"}
                                label={"Image Url*"}
                                placeholder={"Image URL"}
                                size={"large"}
                                value={newItem?.imageUrl}
                                handleChange={(e) =>
                                    setNewItem({
                                        ...newItem,
                                        imageUrl: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col md={4} className="mb-2">
                            <Label className="fw-bold">Upload Image</Label>
                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    style={{ display: "none" }}
                                    id="product-image-upload"
                                />
                                <label
                                    htmlFor="product-image-upload"
                                    className="btn btn-primary mb-0 d-flex align-items-center justify-content-center w-100"
                                    style={{ height: "40px", cursor: "pointer" }}
                                >
                                    {newItem?.tempImageFile ? "Change File" : "Select File"}
                                </label>
                            </div>
                            {newItem?.tempImageFile && (
                                <div className="mt-1 small text-muted text-truncate" style={{ maxWidth: "200px" }}>
                                    Selected: {newItem.tempImageFile.name}
                                </div>
                            )}
                        </Col>
                        {previewUrl && (
                            <Col md={12} className="mt-2 text-end">
                                <img
                                    src={previewUrl}
                                    alt="Product Preview"
                                    className="img-fluid rounded border shadow-sm bg-white"
                                    style={{ maxHeight: '60px', maxWidth: '100px', objectFit: 'contain' }}
                                />
                            </Col>
                        )}
                    </Row>
                </Col>
                <Col md={3}>
                    <FormInput
                        type={"text"}
                        label={"Length(IN)*"}
                        placeholder={"e.g. 10 or 10-12"}
                        size={"large"}
                        value={newItem?.length ?? ""}
                        handleChange={(e) =>
                            setNewItem({
                                ...newItem,
                                length: e.target.value,
                            })
                        }
                    />
                </Col>
                <Col md={3}>
                    <FormInput
                        type={"text"}
                        label={"Height(IN)*"}
                        placeholder={"e.g. 10 or 10-12"}
                        size={"large"}
                        value={newItem?.height ?? ""}
                        handleChange={(e) =>
                            setNewItem({
                                ...newItem,
                                height: e.target.value,
                            })
                        }
                    />
                </Col>
                <Col md={3}>
                    <FormInput
                        type={"text"}
                        label={"Width(IN)*"}
                        placeholder={"e.g. 10 or 10-12"}
                        size={"large"}
                        value={newItem?.width ?? ""}
                        handleChange={(e) =>
                            setNewItem({
                                ...newItem,
                                width: e.target.value,
                            })
                        }
                    />
                </Col>
                <Col md={3}>
                    <FormInput
                        type={"number"}
                        label={"Weight(LBS)*"}
                        placeholder={""}
                        size={"large"}
                        value={newItem?.weight}
                        handleChange={(e) =>
                            setNewItem({
                                ...newItem,
                                weight: e.target.value,
                            })
                        }
                    />
                </Col>
            </Row>
                </CardBody>
            </Card>

            <Card className="border-0 shadow-sm mb-4 bg-light">
                <CardBody className="p-4">
                    <div className="d-flex align-items-center gap-2 mb-4 pb-2 border-bottom">
                        <div className="bg-primary-soft p-2 rounded-3 text-primary">
                            <FiSettings size={16} />
                        </div>
                        <h6 className="fw-bold text-dark mb-0 text-uppercase tracking-wider" style={{ fontSize: '13px' }}>Settings</h6>
                    </div>
                    <Row className="g-2">
                <Col md={3}>
                    <FormInput
                        dropdown
                        type={"number"}
                        label={"Display"}
                        placeholder={"select"}
                        className={`bg-white border rounded`}
                        size={"large"}
                        value={newItem?.display}
                        options={newItemSettings}
                        handleChange={(value) => {
                            setNewItem({
                                ...newItem,
                                display: value,
                            });
                        }}
                    />
                </Col>
                <Col md={3}>
                    <FormInput
                        dropdown
                        type={"number"}
                        label={"Feed"}
                        placeholder={"select"}
                        className={`bg-white border rounded`}
                        size={"large"}
                        value={newItem?.feed}
                        options={newItemSettings}
                        handleChange={(value) => {
                            setNewItem({
                                ...newItem,
                                feed: value,
                            });
                        }}
                    />
                </Col>
                <Col md={3}>
                    <FormInput
                        dropdown
                        type={"number"}
                        label={"Reset Quantity"}
                        placeholder={"select"}
                        className={`bg-white border rounded`}
                        size={"large"}
                        value={newItem?.reset_qty}
                        options={newItemSettings}
                        handleChange={(value) => {
                            setNewItem({
                                ...newItem,
                                reset_qty: value,
                            });
                        }}
                    />
                </Col>
                <Col md={3}>
                    <FormInput
                        dropdown
                        type={"number"}
                        label={"Facebook Ignore"}
                        placeholder={"select"}
                        className={`bg-white border rounded`}
                        size={"large"}
                        value={newItem?.facebook_ignore}
                        options={newItemSettings}
                        handleChange={(value) => {
                            setNewItem({
                                ...newItem,
                                facebook_ignore: value,
                            });
                        }}
                    />
                </Col>
                <Col md={3} className="mt-4">
                    <div className="d-flex align-items-center gap-2">
                        <Input
                            type="checkbox"
                            id="hotselling"
                            className="m-0"
                            style={{ borderColor: "#ccc" }}
                            checked={newItem?.hotselling || false}
                            onChange={(e) =>
                                setNewItem({
                                    ...newItem,
                                    hotselling: e.target.checked,
                                })
                            }
                        />
                        <Label htmlFor="hotselling" className="mb-0 d-flex align-items-center gap-1">
                            Hot Selling <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Mark this product as Hot Selling"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip>
                        </Label>
                    </div>
                </Col>
                <Col md={3} className="mt-4">
                    <div className="d-flex align-items-center gap-2">
                        <Input
                            type="checkbox"
                            id="homePageHotSelling"
                            className="m-0"
                            style={{ borderColor: "#ccc" }}
                            checked={newItem?.homePageHotSelling || false}
                            onChange={(e) =>
                                setNewItem({
                                    ...newItem,
                                    homePageHotSelling: e.target.checked,
                                })
                            }
                        />
                        <Label htmlFor="homePageHotSelling" className="mb-0 d-flex align-items-center gap-1">
                            Home Page Hot Selling <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Feature this product on the Home Page"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip>
                        </Label>
                    </div>
                </Col>
                <Col md={3} className="mt-4">
                    <div className="d-flex align-items-center gap-2">
                        <Input
                            type="checkbox"
                            id="updatePriceFromDnh"
                            className="m-0"
                            style={{ borderColor: "#ccc" }}
                            checked={newItem?.updatePriceFromDnh}
                            onChange={(e) => {
                                setNewItem({
                                    ...newItem,
                                    updatePriceFromDnh: e.target.checked,
                                });
                            }}
                        />
                        <Label htmlFor="updatePriceFromDnh" className="mb-0 d-flex align-items-center gap-1">
                            Update Price From DNH <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Automatically sync and update price from DNH"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip>
                        </Label>
                    </div>
                </Col>
                <Col md={3} className="mt-4">
                    <div className="d-flex align-items-center gap-2">
                        <Input
                            type="checkbox"
                            id="visible"
                            className="m-0"
                            style={{ borderColor: "#ccc" }}
                            checked={newItem?.visible ?? true}
                            onChange={(e) =>
                                setNewItem({
                                    ...newItem,
                                    visible: e.target.checked,
                                })
                            }
                        />
                        <Label htmlFor="visible" className="mb-0 d-flex align-items-center gap-1">
                            Visible <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Make this product visible in the public catalog"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip>
                        </Label>
                    </div>
                </Col>
            </Row>
                </CardBody>
            </Card>
        </>
    );
};

export default Step4LogisticsMedia;
